import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPDPath} from '../../../utils/custom-utils'

/**
 * Link Banner component
 *
 * @param {Object} props.custom - Image Link.
 * @param {string} props.ITCText - Sub Line.
 * @param {string} props.ITCLink - Link URL.
 * @param {string} props.heading - Head Line.
 * @param {string} props.alt - Image alt text.
 * @returns {React.ReactElement} - ImageWithText component.
 */
export const PromotionalContentTileBanner = ({custom, ITCText, ITCLink, heading, alt}) => {
    const styles = useMultiStyleConfig('containerStyles')
    const promotionalStyle = useMultiStyleConfig('promotionalContentTileBanner')
    const {site, locale} = useMultiSite()
    const imageURL = custom?.image?.disBaseLink
    const formattedTileUrl = getPDPath(ITCLink, site, locale)

    return (
        <Box className="promotional-content-tile-banner" {...styles.containerStyles}>
            <Link to={formattedTileUrl}>
                <Box {...promotionalStyle.promotionalBlock}>
                    {imageURL && (
                        <Image
                            src={imageURL}
                            alt={alt || 'promotional-content-tile-banner-image'}
                        />
                    )}

                    {heading && (
                        <Box
                            {...promotionalStyle.promotionalHeading}
                            dangerouslySetInnerHTML={{__html: heading}}
                        />
                    )}
                </Box>
            </Link>

            {ITCText && (
                <Box
                    {...promotionalStyle.promotionalSubHeading}
                    dangerouslySetInnerHTML={{__html: ITCText}}
                />
            )}
        </Box>
    )
}

PromotionalContentTileBanner.propTypes = {
    custom: PropTypes.object,
    ITCLink: PropTypes.string,
    ITCText: PropTypes.string,
    heading: PropTypes.string,
    alt: PropTypes.string
}

export default PromotionalContentTileBanner
